import LoadingSpinnerView from './LoadingSpinnerView';
export default LoadingSpinnerView;
